/**
 * Get selected object by id
 * 
 * @param {*} elements 
 * @param {*} id 
 * @returns 
 */
export function getSelectedObject(elements, id) {
    let selected = null;

    if (id && elements && elements.length > 0) {
        elements.forEach(element => {
            if (parseInt(element.external_id) === parseInt(id)) {
                selected = element;
            }
        });
    }

    return selected;
}

/**
 * Get selected object by id
 * 
 * @param {*} elements 
 * @param {*} id 
 * @returns 
 */
export function getSelectedObjectByID(elements, id) {
    let selected = null;

    if (id && elements && elements.length > 0) {
        elements.forEach(element => {
            if (parseInt(element.object_id) === parseInt(id)) {
                selected = element;
            }
        });
    }

    return selected;
}
